export const en = {
  // ── Navigation ──────────────────────────────────────
  "nav.dashboard":       "Dashboard",
  "nav.devices":         "Devices",
  "nav.zones":           "Zones",
  "nav.companies":       "Companies",
  "nav.schedule":        "Schedule",
  "nav.templates":       "Templates",
  "nav.log":             "Log",
  "nav.settings":        "Settings",
  "nav.section.main":    "Main",
  "nav.section.content": "Content",
  "nav.section.admin":   "Admin",

  // ── Topbar ───────────────────────────────────────────
  "topbar.addSchedule": "Add Schedule",
  "topbar.logout":      "Logout",
  "topbar.theme":       "Toggle theme",

  // ── User ─────────────────────────────────────────────
  "user.admin":    "Administrator",
  "user.operator": "Operator",

  // ── Device status ────────────────────────────────────
  "status.master":  "Master",
  "status.client":  "Client",
  "status.offline": "Offline",
  // Legacy (kept for backward compat)
  "status.online":  "Client",
  "status.server":  "Master",

  // ── Devices page ─────────────────────────────────────
  "devices.title":        "Devices",
  "devices.search":       "Search by ID or company…",
  "devices.allCompanies": "All companies",
  "devices.allStatuses":  "All statuses",
  "devices.hideOffline":  "Hide offline",
  "devices.showOffline":  "Show all",
  "devices.total":        "Total",
  "devices.online":       "Online",
  "devices.offline":      "Offline",
  "devices.commands":     "Commands",
  "devices.nowPlaying":   "Playing",
  "devices.lastSeen":     "Last seen",
  "devices.command":      "Command",
  "devices.actions":      "Actions",
  "devices.zone":         "Zone",
  "devices.group":        "Company",
  "devices.rackName":     "Rack name",
  "devices.files":        "Files",
  "devices.startSelected": "Start selected",
  "devices.stopSelected":  "Stop selected",
  "devices.updateSelected": "Update video",
  "devices.deleteVideo":    "Delete video",
  "devices.viewTable":      "Table",
  "devices.viewCards":      "Cards",
  "devices.viewGroups":     "Companies",

  // ── Device commands ──────────────────────────────────
  "cmd.play":          "Play",
  "cmd.stop":          "Stop",
  "cmd.startall":      "Start all",
  "cmd.stopall":       "Stop all",
  "cmd.updatevideo":   "Update video",
  "cmd.deletevideo":   "Delete video",
  "cmd.activate":      "Activate",
  "cmd.appclose":      "Close app",
  "cmd.upd_playlist":  "Update playlist",
  "cmd.upd_settings":  "Update settings",

  // ── Zones page ───────────────────────────────────────
  "zones.title":         "Zones",
  "zones.create":        "New zone",
  "zones.onlineOnly":    "Online only",
  "zones.showAll":       "Show all",
  "zones.totalZones":    "Total zones",
  "zones.onlineDevices": "Online devices",
  "zones.synced":        "Synced",
  "zones.diffFiles":     "Different files",
  "zones.filesMatch":    "Files match",
  "zones.filesDiff":     "Different files",
  "zones.allOffline":    "All offline",
  "zones.noDevices":     "No devices",
  "zones.addDevice":     "Add device",
  "zones.backToZones":   "← Back",
  "zones.manageDevices": "Manage devices",

  // ── Schedule page ────────────────────────────────────
  "schedule.title":       "Schedule",
  "schedule.add":         "+ Add schedule",
  "schedule.allTasks":    "All tasks",
  "schedule.newTask":     "+ New task",
  "schedule.month":       "Month",
  "schedule.week":        "Week",
  "schedule.today":       "Today",
  "schedule.zone":        "Zone",
  "schedule.allZones":    "All zones",
  "schedule.playlist":    "Playlist (files separated by comma)",
  "schedule.time":        "Start time",
  "schedule.days":        "Days of week",
  "schedule.advance":     "Send N minutes before",
  "schedule.workdays":    "Weekdays",
  "schedule.weekends":    "Weekends",
  "schedule.all":         "All",
  "schedule.active":      "Active",
  "schedule.disabled":    "Disabled",
  "schedule.files":       "Files",
  "schedule.recurrence":  "Recurrence",
  "schedule.name":        "Task name",
  "schedule.step1":       "Settings",
  "schedule.step2":       "Playlist",
  "schedule.step3":       "Validation",

  // ── Companies (admin) ────────────────────────────────
  "companies.title":  "Companies",
  "companies.create": "Create company",

  // ── Settings page ────────────────────────────────────
  "settings.users":       "Users",
  "settings.account":     "Account",
  "settings.newPassword": "New password",
  "settings.login":       "Login",
  "settings.email":       "Email",
  "settings.password":    "Password",
  "settings.company":     "Company",

  // ── Dashboard ────────────────────────────────────────
  "dashboard.activity":      "Device activity",
  "dashboard.todaySchedule": "Today's schedule",
  "dashboard.quickActions":  "Quick actions",
  "dashboard.allCompanies":  "All companies",
  "dashboard.live":          "live",
  "dashboard.details":       "Details",
  "dashboard.noEvents":      "No events",
  "dashboard.emptySchedule": "No schedules",
  "dashboard.play":          "Play",
  "dashboard.stop":          "Stop",
  "dashboard.updateVideo":   "Update video",
  "dashboard.companies":     "companies",
  "dashboard.statusOffline": "offline",
  "dashboard.statusRunning": "running",
  "dashboard.statusOnline":  "connected",
  "nav.groups":              "Companies",

  // ── New Screens platform ─────────────────────────────
  "nav.screens":              "Screens",
  "nav.old":                  "Old Platform",
  "nav.section.newplatform":  "New Platform",
  "screens.title":            "Screens",
  "screens.addScreen":        "Add Screen",
  "screens.deviceId":         "Device ID",
  "screens.displayName":      "Display Name",
  "screens.status":           "Status",
  "screens.lastSeen":         "Last Seen",
  "screens.appVersion":       "App Version",
  "screens.actions":          "Actions",
  "screens.online":           "Online",
  "screens.offline":          "Offline",
  "screens.activateTitle":    "Activate New Screen",
  "screens.activateDesc":     "Enter the 9-digit code displayed on the TV screen",
  "screens.codeLabel":        "Activation Code",
  "screens.activateBtn":      "Activate",
  "screens.noScreens":        "No screens yet. Activate your first device.",
  "screens.never":            "Never",
  "screens.detail.title":     "Screen Details",
  "screens.detail.info":      "Information",
  "screens.detail.ip":        "IP Address",
  "screens.detail.since":     "Added",
  "screens.detail.configVer": "Config version",
  "screens.detail.tabSettings":    "Settings",
  "screens.detail.tabScreenshot":  "Screenshot",
  "screens.detail.content":        "Content Settings",
  "screens.detail.defaultContent": "Default Content",
  "screens.detail.scheduledContent": "Scheduled Content",
  "screens.detail.contentPlaylist": "Playlist",
  "screens.detail.contentMedia":   "Media File",
  "screens.detail.contentOff":     "Turned Off",
  "screens.detail.noSchedule":     "No schedule",
  "screens.detail.chooseFile":     "Choose file…",
  "screens.detail.scale":          "Scale",
  "screens.detail.scaleFill":      "Fill",
  "screens.detail.scaleFit":       "Fit",
  "screens.detail.scaleStretch":   "Stretch",
  "screens.detail.selectedFile":   "Selected file",
  "screens.detail.noPlaylists":    "No playlists",
  "screens.detail.tabMedia":       "Media",
  "screens.detail.tabLogs":        "Logs",
  "screens.detail.savePublish":    "Save & Publish",
  "screens.detail.publishing":     "Publishing…",
  "screens.detail.published":      "Published",
  "screens.detail.publishFailed":  "Failed",
  "screens.detail.debugMode":          "Debug Mode",
  "screens.detail.debugModeHint":      "Show on-device overlay with sync and playback info",
  "screens.detail.crashLogEnabled":    "Send Crash Reports",
  "screens.detail.crashLogEnabledHint":"Allow the device to send crash logs to the server",
  "screens.detail.kioskMode":          "Kiosk Mode",
  "screens.detail.kioskModeHint":      "Pin app to screen — prevent users from exiting",
  "screens.detail.autostart":               "Autostart on boot",
  "screens.detail.autostartHint":           "Launch the app automatically when the device powers on",
  "screens.detail.disableStandby":     "Disable Standby",
  "screens.detail.disableStandbyHint": "Keep the screen always on, disable sleep timeout",
  "screens.detail.screenOrientation":       "Screen orientation",
  "screens.detail.screenOrientationHint":   "Rotates the whole app, including settings and overlays",
  "screens.detail.contentRotation":         "Content rotation",
  "screens.detail.contentRotationHint":     "Rotates only the playing content — use when the panel hangs sideways",
  "screens.detail.tabCommands":    "Commands",
  "screens.cacheTtlDays":            "Cache TTL (days)",
  "screens.cacheTtlHint":            "Delete unused files from device after N days. 0 = keep forever.",
  "screens.cacheTtlForever":         "Keep forever",
  "screens.cacheTtlDaysUnit":        "days",
  "screens.offlineTimeoutDays":      "Offline lock (days)",
  "screens.offlineTimeoutHint":      "Stop playback if device had no server contact for N days. 0 = unlimited.",
  "screens.offlineTimeoutUnlimited": "Unlimited",
  "screens.cachedFiles":           "Files on Device",
  "screens.cachedFilesCount":      "files",
  "screens.clearCache":            "Clear All",
  "screens.deleteUnused":          "Delete Unused",
  "screens.cmdSent":               "Command sent — device will apply within 30 sec",
  "screens.cmdQueue":              "Command Queue",
  "screens.noPendingCmds":        "No pending commands",
  "screens.noCachedFiles":         "No files cached on device",
  "screens.bitDepthWarnTitle":     "10-bit video detected",
  "screens.bitDepthWarnDesc":      "The following files use 10-bit color depth and may not play on Android devices:",
  "screens.bitDepthConvertDesc":   "Convert to 8-bit (H.264/yuv420p) for maximum device compatibility. Original files will be replaced.",
  "screens.bitDepthConvert":       "Convert to 8-bit",
  "screens.bitDepthConverting":    "Converting… this may take a few minutes",
  "screens.bitDepthPublishAnyway": "Publish anyway",
  "screens.deviceControl":  "Device Control",
  "screens.autostart":      "Autostart on boot",
  "screens.autostartHint":  "App launches automatically after reboot",
  "screens.volume":         "Volume",
  "screens.volumeSet":      "Set",
  "screens.wakeScreen":     "Wake Screen",
  "screens.screenOff":      "Screen Off",
  "screens.restartApp":     "Restart App",
  "screens.rebootDevice":   "Reboot Device",
  "screens.syncNtp":        "Sync Time",
  "screens.apkUpdate":      "Software Update",
  "screens.downloadUpdate": "Download Latest",
  "screens.downloadApk":    "Download APK",
  "screens.installSilent":  "Install Silently",
  "screens.installLoud":    "Install Loudly",
  "screens.fetchingVer":    "Fetching version…",

  // ── Common ───────────────────────────────────────────
  // ── Media library ────────────────────────────────────
  "nav.media":              "Media",
  "nav.playlists":          "Playlists",
  "nav.playlists2":         "Playlist 2",

  // ── Playlists ──────────────────────────────────────────
  "playlists.title":        "Playlists",
  "playlists.new":          "New Playlist",
  "playlists.newName":      "New Playlist",
  "playlists.namePlaceholder": "Playlist name…",
  "playlists.empty":        "No playlists yet",
  "playlists.emptyHint":    "Click «New Playlist» to get started",
  "playlists.saved":        "Saved",
  "playlists.deleteTitle":  "Delete playlist?",
  "playlists.deleteHint":   "This will permanently delete the playlist and all its items.",
  "playlists.colName":      "Name",
  "playlists.colItems":     "Items",
  "playlists.colDuration":  "Duration",
  "playlists.colUpdated":   "Updated",
  "playlists.description":  "Description",
  "playlists.descPlaceholder": "Optional description…",
  "playlists.transition":   "Transition",
  "playlists.tr_cut":       "Cut",
  "playlists.tr_fade":      "Fade",
  "playlists.tr_slide":     "Slide",
  "playlists.trDuration":   "Duration",
  "playlists.playback":     "Playback",
  "playlists.noBlackGap":   "No black gap",
  "playlists.random":       "Random order",
  "playlists.syncEnabled":  "Sync across devices",
  "playlists.duplicate":    "Duplicate",
  "playlists.queue":        "Queue",
  "playlists.queueEmpty":   "Add files from the library below",
  "playlists.library":      "Media Library",
  "playlists.noMedia":      "No media files uploaded yet",
  "playlists.dblClickToAdd": "dbl-click to add",
  "playlists.dragToInsert":  "drag to insert",
  "playlists.noSelected":    "Select a playlist",
  "playlists.queueEmptyHint": "Drag & drop files here",
  "playlists.settingsTab":   "Settings",
  "playlists.shuffle":       "Shuffle",
  "playlists.clearAll":      "Clear all",
  "playlists.addMedia":      "Add media",

  "media.newFolder":        "New Folder",
  "media.allFiles":         "All Files",
  "media.folders":          "Folders",
  "media.noFolders":        "No folders yet",
  "media.storage":          "Storage",
  "media.selectFile":       "Select a file to preview",
  "media.searchPlaceholder":"Search files and folders…",
  "media.uploadFiles":      "Upload",
  "media.dropHere":         "Drop files to upload into",
  "media.noFiles":          "No files in this folder",
  "media.uploadHint":       "Click «Upload files» or drop files here",
  "media.resolution":       "Resolution",
  "media.size":             "Size",
  "media.bitrate":          "Bitrate",
  "media.codec":            "Codec",
  "media.colorDepth":       "Color depth",
  "media.colorDepthWarn":   "May not play on some devices",
  "media.duration":         "Duration",
  "media.format":           "Format",
  "media.uploaded":         "Uploaded",
  "media.lastPlayed":       "Last Played",
  "media.colName":          "Name",
  "media.colStatus":        "Status",
  "media.colSize":          "Size",
  "media.colResolution":    "Resolution",
  "media.colDuration":      "Duration",
  "media.colLastPlayed":    "Last Played",
  "media.colCreatedAt":     "Date Added",
  "media.availPeriod":      "Availability period",
  "media.scheduled":        "Scheduled",
  "media.from":             "From",
  "media.until":            "Until",
  "media.addTimeRange":     "Add time range",
  "media.statusActive":     "Active",
  "media.statusExpired":    "Expired",
  "media.statusNotStarted": "Not started",
  "media.usedInTitle":      "File is in use",
  "media.usedInDesc":       "cannot be deleted while it is used in:",
  "media.usedInPlaylists":  "Playlists",
  "media.usedInScreens":    "Screens (default content)",
  "media.usedInSchedules": "Schedules",
  "media.usedInHint":       "Remove the file from all playlists and screens before deleting.",
  "media.defaultContent":   "Default content",
  "media.transcoding":      "Converting in progress",
  "media.transcodingDesc":  "— file is being converted to 8-bit H.264. Wait for the conversion to finish before deleting.",
  "media.blockedCount":     "{{count}} files in selection could not be deleted",

  "nav.schedules":                  "Schedules",
  "schedules.title":                "Schedules",
  "schedules.new":                  "New Schedule",
  "schedules.duplicate":            "Duplicate",
  "schedules.empty":                "No schedules yet. Create your first one.",
  "schedules.allSchedules":         "All Schedules",
  "schedules.newEvent":             "New Record",
  "schedules.saveNeedsRecord":    "Add a record before saving",
  "schedules.editEvent":            "Edit Record",
  "schedules.newRecord":            "New Record",
  "schedules.editRecord":           "Edit Record",
  "schedules.starts":               "Starts",
  "schedules.ends":                 "Ends",
  "schedules.dateTime":             "Date & Time",
  "schedules.dateLocked":           "Date locked",
  "schedules.timesInTz":            "Times in {{tz}}",
  "schedules.startRequired":        "Start date and time are required",
  "schedules.endRequired":          "End time is required",
  "schedules.endBeforeStart":       "End must be after start",
  "schedules.overlapError":         "Overlaps with existing record",
  "schedules.today":                "Today",
  "schedules.day":                  "Day",
  "schedules.week":                 "Week",
  "schedules.month":                "Month",
  "schedules.settings":             "Settings",
  "schedules.eventType":            "Event Type",
  "schedules.scheduleContent":      "Schedule Content",
  "schedules.screenOff":            "Turn screen Off",
  "schedules.content":              "Content",
  "schedules.playlist":             "Playlist",
  "schedules.eventStarts":          "Event Starts",
  "schedules.eventEnds":            "Event Ends",
  "schedules.repeatOptions":        "Repeat Options",
  "schedules.repeat":               "Repeat",
  "schedules.repeatEvery":          "Repeat Every",
  "schedules.doesNotRepeat":        "Does not repeat",
  "schedules.daily":                "Daily (Mon-Sun)",
  "schedules.weekday":              "Every weekday (Mon-Fri)",
  "schedules.weekly":               "Weekly (every {{day}})",
  "schedules.monthly":              "Monthly (on the {{n}}th day)",
  "schedules.annually":             "Annually (on {{date}})",
  "schedules.custom":               "Custom",
  "schedules.forever":              "Forever",
  "schedules.customDate":           "Custom Date and Time",
  "schedules.customOccurrences":    "Custom Occurrences",
  "schedules.occurrences":          "times",
  "schedules.timezone":             "The schedule runs on the screens' local time zone.",
  "schedules.weekdaySun": "Sunday",  "schedules.weekdayMon": "Monday",  "schedules.weekdayTue": "Tuesday",
  "schedules.weekdayWed": "Wednesday","schedules.weekdayThu": "Thursday","schedules.weekdayFri": "Friday", "schedules.weekdaySat": "Saturday",
  "schedules.monthJan": "January",  "schedules.monthFeb": "February", "schedules.monthMar": "March",
  "schedules.monthApr": "April",    "schedules.monthMay": "May",      "schedules.monthJun": "June",
  "schedules.monthJul": "July",     "schedules.monthAug": "August",   "schedules.monthSep": "September",
  "schedules.monthOct": "October",  "schedules.monthNov": "November", "schedules.monthDec": "December",
  "schedules.events":               "events",
  "schedules.screens":              "screens",
  "schedules.noPlaylist":           "Select playlist…",
  "schedules.deleteConfirm":        "Delete this schedule? All events will be removed.",

  "nav.logs":   "Logs",
  "logs.title":         "Device Logs",
  "logs.allDevices":    "All devices",
  "logs.allLevels":     "All levels",
  "logs.allCategories": "All categories",
  "logs.device":        "Device",
  "logs.level":         "Level",
  "logs.category":      "Category",
  "logs.message":       "Message",
  "logs.time":          "Time",
  "logs.autoRefresh":   "Auto-refresh",
  "logs.clearAll":      "Clear all",
  "logs.noLogs":        "No logs yet",
  "logs.tabDebug":      "Debug",
  "logs.tabPlayback":   "Playback",
  "logs.pbName":        "Name",
  "logs.pbStatus":      "Status",
  "logs.pbFile":        "File",
  "logs.pbPlaylist":    "Playlist",
  "logs.pbDuration":    "Duration",

  "playlists.publishedToScreens": "Published to {{count}} screen(s)",
  "schedules.publishedToScreens": "Published to {{count}} screen(s)",

  "schedules.records":              "Records",
  "schedules.noRecords":            "No records in this period",
  "schedules.repeatOnce":           "One-off",
  "schedules.repeatDaily":          "Every day",
  "schedules.repeatWeekday":        "Weekdays",
  "schedules.repeatWeekly":         "Every week",
  "schedules.repeatMonthly":        "Every month",
  "schedules.repeatAnnually":       "Every year",
  "schedules.repeatEveryDays":      "Every {{count}} days",
  "schedules.repeatEveryWeeks":     "Every {{count}} weeks",
  "schedules.repeatEveryMonths":    "Every {{count}} months",
  "schedules.repeatEveryYears":     "Every {{count}} years",
  "schedules.repeatAt":             "at {{time}}",
  "schedules.repeatUntil":          "until {{date}}",
  "schedules.repeatTimes":          "{{count}} times",
  "schedules.startsOn":             "from {{date}}",
  "schedules.nextRun":              "next: {{date}}",

  "screens.dangerZone":         "Danger Zone",
  "screens.deleteDevice":       "Delete Device",
  "screens.deleteDeviceConfirm": "Delete this screen permanently?",

  "screens.bulk.screenCount_one":   "{{count}} screen",
  "screens.bulk.screenCount_other": "{{count}} screens",
  "screens.bulk.reloadConfig":      "Reload Config",
  "screens.bulk.reloadConfigTitle": "Reload config on selected devices",
  "screens.bulk.syncFiles":         "Sync Files",
  "screens.bulk.syncFilesTitle":    "Sync files on selected devices",
  "screens.bulk.bulkEdit":          "Bulk Edit",
  "screens.bulk.clearSelection":    "Clear selection",
  "screens.bulk.modalTitle":        "Bulk Edit",
  "screens.bulk.screensSelected":   "{{count}} screens selected",
  "screens.bulk.defaultContent":    "Default Content",
  "screens.bulk.selectPlaylist":    "— select playlist —",
  "screens.bulk.scheduledContent":  "Scheduled Content",
  "screens.bulk.selectSchedule":    "— select schedule —",
  "screens.bulk.orientation":       "Screen Orientation",
  "screens.bulk.landscape":         "Landscape",
  "screens.bulk.portrait":          "Portrait",
  "screens.bulk.revLandscape":      "Rev. Landscape",
  "screens.bulk.revPortrait":       "Rev. Portrait",
  "screens.bulk.contentRotation":   "Content Rotation",
  "screens.bulk.autostart":         "Autostart on Boot",
  "screens.bulk.standby":           "Disable Standby",
  "screens.bulk.company":           "Company",
  "screens.bulk.selectCompany":     "Select company…",
  "screens.bulk.enabled":           "Enabled",
  "screens.bulk.disabled":          "Disabled",
  "screens.bulk.fieldsWillChange_one":   "{{count}} field will be changed",
  "screens.bulk.fieldsWillChange_other": "{{count}} fields will be changed",
  "screens.bulk.selectFields":      "Select fields to change",
  "screens.bulk.cancel":            "Cancel",
  "screens.bulk.applying":          "Applying…",
  "screens.bulk.apply_one":         "Apply to {{count}} screen",
  "screens.bulk.apply_other":       "Apply to {{count}} screens",
  "screens.deleting":            "Deleting…",

  "cmdQueue.title":       "Command Queue",
  "cmdQueue.screen":      "Screen",
  "cmdQueue.command":     "Command",
  "cmdQueue.status":      "Status",
  "cmdQueue.createdAt":   "Created",
  "cmdQueue.empty":       "No pending commands",
  "cmdQueue.refresh":     "Refresh",
  "cmdQueue.publish":     "Publish All",
  "cmdQueue.publishing":  "Publishing…",

  // ── Login ────────────────────────────────────────
  "login.subtitle":            "Sign in to your account",
  "login.loginPlaceholder":    "Enter your login",
  "login.emailPlaceholder":    "Enter your email",
  "login.passwordPlaceholder": "Enter your password",
  "login.error":               "Invalid login or password",
  "login.signingIn":           "Signing in…",
  "login.signIn":              "Sign In",

  "common.save":    "Save",
  "common.cancel":  "Cancel",
  "common.delete":  "Delete",
  "common.rename":    "Rename",
  "common.duplicate": "Duplicate",
  "common.edit":    "Edit",
  "common.add":     "Add",
  "common.search":  "Search…",
  "common.loading": "Loading…",
  "common.of":      "of",
  "common.hidden":  "hidden",
  "common.back":    "Back",
  "common.close":   "Close",
  "common.yes":     "Yes",
  "common.no":      "No",
  "common.more":    "more",
  "common.collapse":"Collapse",
  "common.noData":  "No data",

  // ── Reports ──────────────────────────────────────────
  "nav.reports":                        "Reports",
  "reports.title":                      "Playback reports",
  "reports.period.day":                 "Day",
  "reports.period.week":                "Week",
  "reports.period.month":               "Month",
  "reports.tabContent":                 "Content",
  "reports.tabFiles":                   "Content",
  "reports.tabPlayers":                 "Players",
  "reports.search":                     "Search",
  "reports.searchPlayers":              "Search players…",
  "reports.searchContent":              "Search content…",
  "reports.selectedOf":                 "Selected {{n}} of {{total}} — figures are summed",
  "reports.selectedFooter":            "Selected: {{n}} of {{total}}",
  "reports.nothingSelected":            "Nothing selected",
  "reports.summed":                     "summed",
  "reports.filesWord":                  "clips",
  "reports.playersWord":                "players",
  "reports.playsWord":                  "plays",
  "reports.noData":                     "No data for the period",
  "reports.refresh":                    "Refresh",
  "reports.badgeDetail":               "detail",
  "reports.kpiPlays":                   "Plays",
  "reports.kpiAirtime":                 "Airtime",
  "reports.kpiPlayers":                 "Players",
  "reports.kpiErrors":                  "Interrupted",
  "reports.kpiContent":                "Clips",
  "reports.kpiStatus":                 "Status",
  "reports.byDays":                     "Plays by day",
  "reports.byHours":                    "Hour profile · across the period",
  "reports.byPlayers":                  "By player",
  "reports.videosByPlayer":            "Videos played on this screen",
  "reports.playersForContent":         "Playback by screen",
  "reports.colPlayer":                  "Player",
  "reports.colStatus":                  "Status",
  "reports.colPlays":                   "Plays",
  "reports.colFirst":                   "First play",
  "reports.colLast":                    "Last play",
  "reports.colClip":                   "Clip",
  "reports.colDuration":               "Duration",
  "reports.colShare":                  "Share",
  "reports.airtimeNote":                "Airtime is counted from the nominal clip length, so the figure is reproducible. Actual playback time is wall-clock and varies by a second or two — it is kept for diagnostics only.",
  "reports.viewReportFor":              "View Report for",
  "reports.playerSingular":             "player",
  "reports.reportTitle":                "Report",

  // ── Profile ──────────────────────────────────────────
  "nav.profile":              "Profile",
  "profile.personal":         "Personal Info",
  "profile.firstName":        "First Name",
  "profile.lastName":         "Last Name",
  "profile.email":            "Email",
  "profile.login":            "Login",
  "profile.save":             "Save Changes",
  "profile.saving":           "Saving…",
  "profile.saved":            "Profile saved",
  "profile.saveError":        "Failed to save profile",
  "profile.changePassword":   "Change Password",
  "profile.currentPassword":  "Current Password",
  "profile.newPassword":      "New Password",
  "profile.confirmPassword":  "Confirm New Password",
  "profile.changePasswordBtn":"Change Password",
  "profile.pwdChanged":       "Password changed",
  "profile.pwdError":         "Failed to change password",
  "profile.pwdMismatch":      "Passwords do not match",
  "profile.pwdTooShort":      "Password must be at least 4 characters",
  "profile.appearance":       "Appearance",
  "profile.language":         "Language",
  "profile.theme":            "Theme",
  "profile.dark":             "Dark",
  "profile.light":            "Light",

  "dashboard.playsToday":           "Plays today",
  "dashboard.playsWeek":            "Plays / 7 days",
  "dashboard.attention":            "Needs attention",
  "dashboard.topFiles":             "Top clips today",
  "dashboard.noTally":              "no data",
  "dashboard.noTallyHint":          "Online, but no playback tally for over 2 hours",
  "dashboard.gap":                  "gap",
  "logs.errorsWord":            "errors",
  "logs.clearConfirm":          "Clear all device logs?",
  "logs.footer":                "{{n}} entries · {{errors}} errors. Playback figures live in Reports.",
  "screens.detail.lastSync":        "Last sync",
  "screens.detail.neverSynced":     "never",

  // ── Media dropzone ───────────────────────────────────
  "media.dropZoneMain": "Drop files here",
  "media.dropZoneHint": "or click «Upload files»",

  // ── Settings page (UsersPage) ────────────────────────
  "settings.saved":              "Saved",
  "settings.saving":             "Saving…",
  "settings.mediaSection":       "Media Settings",
  "settings.imageScaleDefault":  "Default image scale",
  "settings.videoScaleDefault":  "Default video scale",
  "settings.transcode8bit":      "Transcode video to 8-bit H.264 on upload",
  "settings.transcode8bitHint":  "Converts to 8-bit H.264 — compatible with all Android devices",
  "settings.autoResize":         "Auto-resize images",
  "settings.comingSoon":         "Coming soon",
  "settings.autoResizeHint":     "Compress images to the selected size on upload",
  "settings.timeSection":        "Time Settings",
  "settings.timezone":           "Timezone",
  "settings.timezoneNow":        "Now in this zone: {{time}}",
  "settings.dst":                "Daylight Saving Time",
  "settings.dstAuto":            "Automatic, by zone rules",
  "settings.dstOff":             "Off — standard time all year",
  "settings.dstChanges":         "Upcoming clock changes",
  "settings.dstDisabled":        "DST is off — time does not change during the year.",
  "settings.dstNoChanges":       "This timezone does not observe DST.",
  "settings.dstForward":         "clock forward",
  "settings.dstBackward":        "clock backward",
  "settings.timeNote":           "Schedules are set in this timezone. The server stores time in UTC, and devices convert it to local time — so a daily event at 10:00 stays at 10:00 after a clock change.",
  "settings.cacheSection":         "Cache Settings",
  "settings.defaultCacheTtl":      "Default cache duration",
  "settings.defaultCacheTtlHint":  "How long devices keep media files cached. Applied to new screens; existing screens retain their own value.",
  "settings.cacheTtlDays":         "days",
  "settings.cacheTtlUnlimited":    "unlimited (keep forever)",
  "settings.offlineSection":       "Offline Activity",
  "settings.offlineTimeoutDays":   "Max offline period",
  "settings.offlineTimeoutHint":   "After this many days without internet, the screen will show a 'Connection lost' message. 0 = unlimited. Applied to new screens; existing screens retain their own value.",
  "settings.offlineDays":          "days",
  "settings.offlineUnlimited":     "unlimited",
  "settings.heartbeatSection":   "Device Heartbeat",
  "settings.hbActive":           "Active mode (sec)",
  "settings.hbActiveHint":       "Interval while portal is active",
  "settings.hbPassive":          "Passive mode (sec)",
  "settings.hbPassiveHint":      "Interval overnight / without activity",
  "settings.hbWindow":           "Active window time (min)",
  "settings.hbWindowHint":       "After last request → passive mode",
  "settings.hbNote":             "After saving, new values will be sent to all devices automatically on the next portal activity.",

  // ── Playlist builder ─────────────────────────────────
  "playlists.queueTitle":          "Playlist ({{count}})",
  "playlists.sortAlpha":           "A→Z",
  "playlists.clearPlaylist":       "✕ Clear",
  "playlists.loadTemplate":        "📋 Load template…",
  "playlists.filesCount":          "({{count}} files)",
  "playlists.saveAsTemplate":      "💾 Save as template",
  "playlists.templateNamePh":      "Template name",
  "playlists.emptyQueue":          "Playlist is empty",
  "playlists.addFromRight":        "Add files from the list on the right",
  "playlists.enterManually":       "Enter files manually",
  "playlists.filesOnDevices":      "Files on devices ({{count}})",
  "playlists.addAll":              "All",
  "playlists.addSelected":         "Add {{count}} selected",
  "playlists.clearSelection":      "Clear",
  "playlists.multiSelectHint":     "Ctrl — toggle, Shift — range",
  "playlists.smartGenerator":      "Smart Generator",
  "common.up":                     "Up",
  "common.down":                   "Down",

  // ── Playlists2 editor ────────────────────────────────
  "playlists2.groupName":      "Group {{n}}",
  "playlists2.groupPlaceholder": "Group name",
  "playlists2.inRotation":     "{{count}} in rotation",
  "playlists2.ungroup":        "Ungroup",
  "playlists2.pass":           "pass {{n}}",
  "playlists2.selected":       "{{count}} selected",
  "playlists2.group":          "Group",
  "playlists2.groupTooltip":   "One airtime slot — files play in rotation, one per pass",
  "playlists2.change":         "Change…",
  "playlists2.scaleName":      "Scale",
  "playlists2.durationName":   "Duration",
  "playlists2.secPlaceholder": "sec",
  "playlists2.apply":          "Apply",
  "playlists2.deselect":       "Deselect",
  "playlists2.occupied":       "{{pct}}% used",
  "playlists2.countCol":       "Count",
  "playlists2.autoMode":       "auto mode",
}
